import "./App.css";
import "./styles/styles.css";

// routes
import AppRouting from "./utils/routing";

function App() {
  return <AppRouting />;
}

export default App;
